<template>
    <div>
        <!-- >>> 'Flight' Part (OUT/RET) -->
        <div class="intro table-wrapper full-width hidden-table-sm box" style="border-spacing: 8px; position: relative;">
            <div class="col-md-4 table-cell sdr-box" v-bind:class="{ xflightIsNotRebookable: flight.rebookable === false }">
                <dl class="term-description">
                    <dt>{{ airline[getCurrentLocale] }}:</dt><dd>FBR/Schauinsland</dd>
                    <dt>{{ flighttype[getCurrentLocale] }}:</dt><dd>Economy</dd>
                    <!-- <dt>{{ flightchange[getCurrentLocale] }}:</dt><dd>{{ avgpers[getCurrentLocale] }}/{{ getRebookingOriginalBookingRebookingFee | rndAmntRUAFWZ }}</dd> -->
                </dl>
            </div>

            <div class="col-md-8 table-cell" v-bind:class="{ xflightIsNotRebookable: flight.rebookable === false }">
                <div class="detailed-features booking-details">
                    <div class="sdr-box">
                        <a class="button btn-mini yellow pull-right" style="cursor: unset;">STOPS: {{ flight.stopAirport === null ? '0' : '1' }}</a>
                        <h4 class="box-title">{{ from[getCurrentLocale] }} {{ flight.departureAirport.location }} {{ to[getCurrentLocale] }}  {{ flight.destinationAirport.location }}<small>{{ outwardflight[getCurrentLocale] }}</small></h4>
                    </div>
                    <div class="table-wrapper flights">
                        <div class="table-row first-flight">
                            <div class="table-cell logo">
                                <img src="/res/images/sdr140x30.png" alt="" style="padding-bottom:3px;">
                                <label>{{ flight.flightNo }}</label>
                            </div>
                            <div class="table-cell timing-detail">
                                <div class="timing">
                                    <div class="check-in">
                                        <label>{{ takeoff[getCurrentLocale] }}</label>
                                        <span>{{ flight.departureDateTime | dateFlightCart }}, {{ flight.departureDateTime | momentTime }}</span>
                                    </div>
                                    <div class="duration text-center">
                                        <i class="soap-icon-clock"></i>
                                        <span>{{ flight.duration | durationFlightCart }}</span>
                                    </div>
                                    <div class="check-out">
                                        <label>{{ landing[getCurrentLocale] }}</label>
                                        <span>{{ flight.destinationDateTime | dateFlightCart }}, {{ flight.destinationDateTime | momentTime }}</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 table-cell" style="position: absolute; top: 0; left: 0; z-index: 10; height: 100%; background: rgba(228, 226,226, .8);" v-if="flight.rebookable === false">
                <p class="center">{{ notrebookableanymore[getCurrentLocale] }}</p>
            </div>
        </div>
        <!-- <<< 'Flight' Part (OUT/RET) -->

        <!-- >>> 'Pax&Srvcs' Part (OUT/RET) -->
        <sdr-rebooking-bookingno-paxdetails :flight="flight" :flightdirection="flightdirection" :modulo="modulo" :mode="mode" :whichcall="whichcall"></sdr-rebooking-bookingno-paxdetails>
        <!-- <<< 'Pax&Srvcs' Part (OUT/RET) -->
    </div>
</template>

<script>
    import PaxDetails from './BookingnoPaxDetails.vue';

    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'flight', 'flightdirection', 'mode', 'whichcall'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-paxdetails': PaxDetails,

        }, // eo components
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> --------------------------
                outwardflight: {
                    en: 'Outward',
                    de: 'Hinflug'
                },
                returnflight: {
                    en: 'Return',
                    de: 'Rückfliug'
                },
                // >>> --------------------------
                airline: {
                    en: 'Airline',
                    de: 'Airline',
                },
                flighttype: {
                    en: 'Flight Type',
                    de: 'Tarif',
                },
                cancellation: {
                    en: 'Name Change',
                    de: 'Namen ändern',
                },
                flightchange: {
                    en: 'Flight Change',
                    de: 'Umbuchung',
                },
                avgpers: {
                    en: 'AVG/PAX',
                    de: 'PRO PAX'
                },
                from: {
                    en: 'From',
                    de: 'Von'
                },
                to: {
                    en: 'to',
                    de: 'nach'
                },
                // >>> --------------------------
                takeoff: {
                    en: 'Take off',
                    de: 'Abflug',
                },
                landing: {
                    en: 'Landing',
                    de: 'Ankunft',
                },
                // >>> --------------------------
                allpassengers: {
                    en: 'Select all passengers',
                    de: 'Alle Passagiere auswählen',
                },
                // >>> --------------------------
                checkallpassengers: {
                    en: 'Select all passengers on this flight',
                    de: 'Alle Passagiere auf diesem Flug wählen'
                },
                newdate: {
                    en: 'Select new flight date',
                    de: 'Neues Flugdatum wählen'
                },
                notrebookableanymore: {
                    en: 'Not rebookable anymore',
                    de: 'Nicht mehr umbuchbar'
                },
                // >>> --------------------------
                today: moment().add(1, 'days').format('DD.MM.YYYY'),

            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getRebookingOriginalBookingRebookingFee',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Filters */
        filters: {

            /*******************************************************************
            * dateFlightCart()
            *
            * Desc:
            *
            * @param {string} date (Date to reformat)
            * @return {string}
            */
            dateFlightCart: function(date) {

                return moment(date, moment.ISO_8601).format('DD.MM.YYYY'); // de:
                // return moment(date, moment.ISO_8601).format('MMM DD, YYYY'); // en: JAN 30, 2019

            }, // dateFlightCart()

            /*******************************************************************
            * durationFlightCart()
            *
            * Desc: Calculates "Travel Time".
            *
            * @param {int} a (duration in seconds)
            * @return {string}
            */
            durationFlightCart: function(a) {

                let hours = Math.floor(a / 3600),
                    minutes = Math.floor(a / 60) - hours * 60,
                    hours_txt = 'S', // H
                    minutes_txt = ' h'; // M


                if (minutes === 0) {
                    return hours + ':00' + minutes_txt;
                } else if (minutes.toString().length === 1) {
                    return hours + ':0' + minutes + '' + minutes_txt;
                } else {
                    return hours + ':' + minutes + '' + minutes_txt;
                }

            }, // eof durationFlightCart()

        }, // eof filters{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([

            ]),

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .flightIsNotRebookable {
        opacity: 0.3;
    }

    .center {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 1.6667em;
        color: #2d3e52;
    }


    #flight-details .flights .first-flight .logo:after {
        bottom: 23px;
    }

    dl.term-description dt {
        color: #FDB714;
    }


    #flight-details .flights {
        padding-bottom: 0px; /* 30 */
    }


    .box {
        margin-bottom: 15px !important;
    }


    .booking-details .other-details {
        background-color: #f5f5f5;
    }
    .booking-details .other-details .total-price-value {
        font-size: 1.9167em;
    }
    .total-price-value-small {
        color: #98ce44;
        font-size: 1.4em;
        text-align: right;
    }
    .booking-details .other-details dt,
    .booking-details .other-details dd {
        padding-top: 0.4em;
        padding-bottom: 0.4em;
    }


    form label {
        text-transform: unset;
        display: block;
        margin-bottom: 5px;
        font-weight: normal;
        font-size: 1.2em;
    }

    input[type=checkbox] {
        transform: scale(1.2);
    }
</style>
